import { Tooltip, Typography } from "@mui/material"
import { TableRecordType } from "../../components/Table"

export const questionsSkillsFormatter = (
  record: TableRecordType,
  prop: string
): any => {
  const reportingCategories = JSON.parse(record[prop] || "[]")

  const count = reportingCategories.length

  if (!count) {
    return "--"
  }

  if (count > 1) {
    return (
      <Tooltip arrow title={reportingCategories.join(", ")}>
        <Typography variant="body2">{`${reportingCategories[0]} + ${
          count - 1
        } more`}</Typography>
      </Tooltip>
    )
  }

  return <Typography variant="body2">{reportingCategories[0]}</Typography>
}
